import { ajax } from 'rxjs/ajax';

const getStayReasons$ = _state$ =>
	ajax.getJSON(`/api/stayReasons`, {
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json',
		},
	});

export default getStayReasons$;
